<template>
  <AppAlert :title="$tt('product_variation.alert_title')" type="warning">
    {{ $tt(`product_variation.note.${variation.name}`, {
        ...variation.type == 'fee' && { fee: displayPrice(variation.fee) },
        ...variation.type == 'stay_limit' && { limit: variation.limit },
      })
    }}
    <template v-if="name">({{ name }})</template>

    <template v-if="variation.type == 'fee'" #append>
      <AppBtn icon="mdi:cart-outline" size="small" @click="$emit('basketClick')" />
    </template>
  </AppAlert>
</template>

<script setup lang="ts">
import { buildFullname } from '~/helpers/format';
import type { ApplicableVariation, Applicant } from '~/types';

const props = defineProps<{
  variation: ApplicableVariation;
  applicant: Applicant;
}>();

const { displayPrice } = useFormat();
const name = computed(() => buildFullname(props.applicant.passport).trim());

defineEmits(['basketClick']);
</script>